import axiosInstance from '../../../config/axiosInstance';
const JobUserDefineService = {
    async GetJobUserDefine(redirectCallback,IssueID,ModuleID) {
        try {                
            const ClientID=localStorage.getItem('CompanyID');           
            const response = await axiosInstance.get(`/Job/GetJobUserDefine?IssueID=${IssueID}&ClientID=${ClientID}&ModuleID=${ModuleID}`);
            return response.data;

        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },  
    
};

export default JobUserDefineService;